import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class Footer extends Component {
  render() {
    const currentYear = new Date().getFullYear()
    return (
      <div className="footer">
        <p className="t-c" style={{ paddingBottom: 24 }}>
          <Link to="/search" id="footer_search">
            <ion-icon name="search"></ion-icon> Search Bible
          </Link>
        </p>
        <p className="t-c">
          Bible prompted journal app by{' '}
          <a
            href="https://www.goodnightjournal.com"
            alt="Goodnight Journal"
            id="footer_goodnightjournal"
          >
            GoodnightJournal.com
          </a>
          <br />
          &copy; Allspectives LLC {currentYear}.
        </p>
      </div>
    )
  }
}

export default Footer
